import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$organizationName/ws/$workspaceId/cb/$codebaseId/$')({
  component: () => null,
  beforeLoad: ({ params, search }) => {
    // Redirect to the new codebase route which does not contain the workspaceId.
    throw redirect({
      to: `/${params.organizationName}/cb/${params.codebaseId}/${params._splat}` as any,
      search: search as any,
    });
  },
});
